import React, { useState } from 'react';
import './OfflineOrder.scss';

const OfflineOrder = () => {
    const [customerInfo, setCustomerInfo] = useState({
        name: '',
        mobile: '',
        address: ''
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [specialInstructions, setSpecialInstructions] = useState('');

    // Mock products data (replace with your actual data source)
    const products = [
        { id: 1, name: 'Product 1', price: 29.99, image: 'product1.jpg' },
        { id: 2, name: 'Product 2', price: 39.99, image: 'product2.jpg' },
        // Add more products
    ];

    const filteredProducts = products.filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleAddProduct = (product) => {
        const existingProduct = selectedProducts.find(p => p.id === product.id);
        if (existingProduct) {
            return;
        }
        setSelectedProducts([...selectedProducts, { ...product, quantity: 1 }]);
    };

    const handleQuantityChange = (productId, newQuantity) => {
        setSelectedProducts(selectedProducts.map(product =>
            product.id === productId ? { ...product, quantity: newQuantity } : product
        ));
    };

    const calculateSubtotal = () => {
        return selectedProducts.reduce((total, product) => 
            total + (product.price * product.quantity), 0);
    };

    const deliveryCharge = 5.00;
    const tax = calculateSubtotal() * 0.1; // 10% tax

    return (
        <div className='offline-order'>
            <div className="customer-info-section">
                <h2>Customer Information</h2>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Customer Name"
                        value={customerInfo.name}
                        onChange={(e) => setCustomerInfo({...customerInfo, name: e.target.value})}
                    />
                    <input
                        type="tel"
                        placeholder="Mobile Number"
                        value={customerInfo.mobile}
                        onChange={(e) => setCustomerInfo({...customerInfo, mobile: e.target.value})}
                    />
                    <textarea
                        placeholder="Delivery Address"
                        value={customerInfo.address}
                        onChange={(e) => setCustomerInfo({...customerInfo, address: e.target.value})}
                    />
                </div>
            </div>

            <div className="product-search-section">
                <h2>Search Products</h2>
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                {searchTerm && (
                    <div className="search-results">
                        {filteredProducts.map(product => (
                            <div key={product.id} className="product-card" onClick={() => handleAddProduct(product)}>
                                <img src={product.image} alt={product.name} />
                                <div className="product-info">
                                    <h3>{product.name}</h3>
                                    <p>${product.price.toFixed(2)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="selected-products-section">
                <h2>Selected Products</h2>
                {selectedProducts.map(product => (
                    <div key={product.id} className="selected-product">
                        <img src={product.image} alt={product.name} />
                        <div className="product-details">
                            <h3>{product.name}</h3>
                            <p>${product.price.toFixed(2)}</p>
                        </div>
                        <div className="quantity-control">
                            <button onClick={() => handleQuantityChange(product.id, Math.max(1, product.quantity - 1))}>-</button>
                            <span>{product.quantity}</span>
                            <button onClick={() => handleQuantityChange(product.id, product.quantity + 1)}>+</button>
                        </div>
                        <div className="product-total">
                            ${(product.price * product.quantity).toFixed(2)}
                        </div>
                    </div>
                ))}
            </div>

            <div className="order-summary">
                <h2>Order Summary</h2>
                <div className="summary-row">
                    <span>Subtotal</span>
                    <span>${calculateSubtotal().toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span>Delivery Charge</span>
                    <span>${deliveryCharge.toFixed(2)}</span>
                </div>
                <div className="summary-row">
                    <span>Tax</span>
                    <span>${tax.toFixed(2)}</span>
                </div>
                <div className="summary-row total">
                    <span>Total</span>
                    <span>${(calculateSubtotal() + deliveryCharge + tax).toFixed(2)}</span>
                </div>
            </div>

            <div className="special-instructions">
                <h2>Special Instructions</h2>
                <textarea
                    placeholder="Add any special instructions..."
                    value={specialInstructions}
                    onChange={(e) => setSpecialInstructions(e.target.value)}
                />
            </div>

            <div className="action-buttons">
                <button className="cancel-btn">Cancel</button>
                <button className="place-order-btn">Place Order</button>
            </div>
        </div>
    );
};

export default OfflineOrder;